import { AddressInput } from '@/shared/ui/address-input';
import { ExtendedAddress } from '../types';
import { Input } from '@/shared/ui';
import { FormikErrors, FormikTouched } from 'formik';
import { withScrollRestoration } from '@/shared/hocs/withScrollRestoration';
import AdditionalAddressInputsNeededAlert from '@/shared/components/address-form/components/additional-address-inputs-needed';

interface AutoAddressProps {
    onAddressInputEvent: () => void;
    onAddressSelection: (address: ExtendedAddress) => void;
    handleManualInput: () => void;
    needsUnit: boolean;
    onAdditionalAddressChange: (value: string) => void;
    handleBlur: (field: string) => void;
    editedAddress?: boolean;
    hideAutocomplete?: boolean;
    values: ExtendedAddress;
    touched: FormikTouched<ExtendedAddress>;
    errors: FormikErrors<ExtendedAddress>;
    alertClassName?: string;
    moreThanOneFieldTouchedAndInsistShowSingleError?: boolean;
    
}

const AutoAddress: React.FC<AutoAddressProps> = ({
    onAddressInputEvent,
    onAddressSelection,
    handleManualInput,
    needsUnit,
    onAdditionalAddressChange,
    handleBlur,
    hideAutocomplete,
    editedAddress,
    values,
    touched,
    errors,
    alertClassName = '',
}) => {
    return (
        <>
            {!hideAutocomplete && (
                <AddressInput
                    label=""
                    name="addressLine1"
                    subLabel="Start typing to search"
                    placeholder="ex. 123 University St."
                    selectedAddress={values}
                    onAddressSeleted={onAddressSelection}
                    onInputChange={onAddressInputEvent}
                    alertClassName={alertClassName}
                    hasDelete={false}
                    hasManualInput
                    onManualInput={handleManualInput}
                    error={touched.addressLine1 && Boolean(errors.addressLine1)}
                    errorMessage={errors.addressLine1}
                />
            )}
            {(needsUnit || values.unit || editedAddress) && (
                <Input
                    className="manual_address__form_elements__unit"
                    label="Apartment/Suite/Box Number"
                    name="unit"
                    type="text"
                    placeholder="ex. #123, Suite 303"
                    value={values.unit}
                    onChange={e => onAdditionalAddressChange(e.target.value)}
                    onBlur={() => handleBlur('unit')}
                    error={touched.unit && Boolean(errors.unit)}
                    errorMessage={errors?.unit}
                    required
                    testId="address-unit"
                    alertClassName={alertClassName}
                    
                />
            )}
            {needsUnit && <AdditionalAddressInputsNeededAlert />}
        </>
    );
};

export default withScrollRestoration(AutoAddress);
